export class AutoLogoutService {
  constructor({
    inactivityTimeout = 8 * 60 * 60 * 1000, // Délai avant d'afficher l'avertissement (ex : 15 min)
    warningTimeout = 2 * 60 * 1000, // Délai après l'avertissement avant déconnexion (ex : 2 min)
    onInactive, // Callback appelé quand l'utilisateur devient inactif
    onTimeout, // Callback appelé quand le délai de grâce est écoulé (déconnexion)
  }) {
    this.inactivityTimeout = inactivityTimeout;

    this.warningTimeout = warningTimeout;

    this.onInactive = onInactive;

    this.onTimeout = onTimeout;

    this.inactivityTimer = null;
    this.warningTimer = null;

    this.handleActivity = this.resetTimer.bind(this);
    this.onStorageEvent = this.onStorageEvent.bind(this);
    this.events = ["keydown", "scroll", "click"];

    window.addEventListener("storage", this.onStorageEvent);
  }

  start() {
    this.events.forEach((e) => window.addEventListener(e, this.handleActivity));
    this.resetTimer();
  }

  stop() {
    this.clearTimers();
    this.events.forEach((e) =>
      window.removeEventListener(e, this.handleActivity)
    );
    window.removeEventListener("storage", this.onStorageEvent);
  }

  onStorageEvent(event) {
    if (event.key === "userActivity") this.resetTimer(false); // Ne pas renvoyer le signal
  }

  resetTimer(broadcast = true) {
    this.clearTimers();
    if (broadcast) localStorage.setItem("userActivity", Date.now());
    this.inactivityTimer = setTimeout(() => {
      if (this.onInactive) this.onInactive();
      this.warningTimer = setTimeout(() => {
        if (this.onTimeout) this.onTimeout();
      }, this.warningTimeout);
    }, this.inactivityTimeout);
  }

  clearTimers() {
    clearTimeout(this.inactivityTimer);
    clearTimeout(this.warningTimer);
  }
}
